import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { RetailerService } from '../api/retailer.service';
import { PagingSettings, StoreTapAndGo, StoreTapAndGoPagingResult } from '../core';

export class OrderSettingsService {
    public static $inject = ['http', '$uibModal', 'retailerService'];

    constructor(
        private http: HttpService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private retailerService: RetailerService
    ) { }

    public getPlaces(query: PagingSettings) {
        return this.http.get<StoreTapAndGoPagingResult>(this.retailerService.tapAndGoPlaces(), { params: query });
    }

    public setPlace(id: number, model: StoreTapAndGo) {
        return this.http.put<void>(this.retailerService.tapAndGoPlace(id), model);
    }

    public generateMonitorKey() {
        return this.http.get<string>(this.retailerService.generateMonitorKey());
    }
}

angular
    .module('naut')
    .service('orderSettingsService', OrderSettingsService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/tapAndGo/order-settings.service.ts